/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_No_Users_AvailableInputs */

const en_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users available`)
};

const fr_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun utilisateur disponible`)
};

const de_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Benutzer verfügbar`)
};

const it_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun utente disponibile`)
};

const ru_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет доступных пользователей`)
};

const es_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay usuarios disponibles`)
};

const zh_cn2_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无可用用户`)
};

const ja_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なユーザーがいません`)
};

const hi_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई उपयोगकर्ता उपलब्ध नहीं हैं`)
};

const pt_pt2_team_manager_no_users_available = /** @type {(inputs: Team_Manager_No_Users_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum usuário disponível`)
};

/**
* | output |
* | --- |
* | "No users available" |
*
* @param {Team_Manager_No_Users_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_no_users_available = /** @type {((inputs?: Team_Manager_No_Users_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_No_Users_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_no_users_available(inputs)
	if (locale === "de") return de_team_manager_no_users_available(inputs)
	if (locale === "it") return it_team_manager_no_users_available(inputs)
	if (locale === "ru") return ru_team_manager_no_users_available(inputs)
	if (locale === "es") return es_team_manager_no_users_available(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_no_users_available(inputs)
	if (locale === "ja") return ja_team_manager_no_users_available(inputs)
	if (locale === "hi") return hi_team_manager_no_users_available(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_no_users_available(inputs)
	return en_team_manager_no_users_available(inputs)
});